/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CountUserAssetsParams,
  GetUserAssetsParams,
  UserAssetDto
} from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType } from '../../orval-mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Authorities: **Any authenticated role**
 */
export const markAllUserAssetsViewed = (
    userId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/${userId}/user-assets/viewed`, method: 'POST', signal
    },
      options);
    }



export const getMarkAllUserAssetsViewedMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAllUserAssetsViewed>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof markAllUserAssetsViewed>>, TError,{userId: string}, TContext> => {

const mutationKey = ['markAllUserAssetsViewed'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markAllUserAssetsViewed>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  markAllUserAssetsViewed(userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkAllUserAssetsViewedMutationResult = NonNullable<Awaited<ReturnType<typeof markAllUserAssetsViewed>>>

    export type MarkAllUserAssetsViewedMutationError = ErrorType<unknown>

    export const useMarkAllUserAssetsViewed = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAllUserAssetsViewed>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markAllUserAssetsViewed>>,
        TError,
        {userId: string},
        TContext
      > => {
      return useMutation(getMarkAllUserAssetsViewedMutationOptions(options), queryClient);
    }
    /**
 * Authorities: **Any authenticated role**
 */
export const getUserAssets = (
    userId: string,
    params: GetUserAssetsParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<UserAssetDto[]>(
      {url: `/api/${userId}/user-assets`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetUserAssetsQueryKey = (userId: string,
    params?: GetUserAssetsParams,) => {
    return [
    `/api/${userId}/user-assets`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetUserAssetsQueryOptions = <TData = Awaited<ReturnType<typeof getUserAssets>>, TError = ErrorType<unknown>>(userId: string,
    params: GetUserAssetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAssets>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserAssetsQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserAssets>>> = ({ signal }) => getUserAssets(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserAssets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserAssetsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserAssets>>>
export type GetUserAssetsQueryError = ErrorType<unknown>


export function useGetUserAssets<TData = Awaited<ReturnType<typeof getUserAssets>>, TError = ErrorType<unknown>>(
 userId: string,
    params: GetUserAssetsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAssets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserAssets>>,
          TError,
          Awaited<ReturnType<typeof getUserAssets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserAssets<TData = Awaited<ReturnType<typeof getUserAssets>>, TError = ErrorType<unknown>>(
 userId: string,
    params: GetUserAssetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAssets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserAssets>>,
          TError,
          Awaited<ReturnType<typeof getUserAssets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserAssets<TData = Awaited<ReturnType<typeof getUserAssets>>, TError = ErrorType<unknown>>(
 userId: string,
    params: GetUserAssetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAssets>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUserAssets<TData = Awaited<ReturnType<typeof getUserAssets>>, TError = ErrorType<unknown>>(
 userId: string,
    params: GetUserAssetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAssets>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserAssetsQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Authorities: **Any authenticated role**
 */
export const getUserAssetById = (
    userId: string,
    id: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<UserAssetDto>(
      {url: `/api/${userId}/user-assets/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetUserAssetByIdQueryKey = (userId: string,
    id: number,) => {
    return [
    `/api/${userId}/user-assets/${id}`
    ] as const;
    }


export const getGetUserAssetByIdQueryOptions = <TData = Awaited<ReturnType<typeof getUserAssetById>>, TError = ErrorType<unknown>>(userId: string,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAssetById>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserAssetByIdQueryKey(userId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserAssetById>>> = ({ signal }) => getUserAssetById(userId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(userId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserAssetById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserAssetByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getUserAssetById>>>
export type GetUserAssetByIdQueryError = ErrorType<unknown>


export function useGetUserAssetById<TData = Awaited<ReturnType<typeof getUserAssetById>>, TError = ErrorType<unknown>>(
 userId: string,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAssetById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserAssetById>>,
          TError,
          Awaited<ReturnType<typeof getUserAssetById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserAssetById<TData = Awaited<ReturnType<typeof getUserAssetById>>, TError = ErrorType<unknown>>(
 userId: string,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAssetById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserAssetById>>,
          TError,
          Awaited<ReturnType<typeof getUserAssetById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserAssetById<TData = Awaited<ReturnType<typeof getUserAssetById>>, TError = ErrorType<unknown>>(
 userId: string,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAssetById>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUserAssetById<TData = Awaited<ReturnType<typeof getUserAssetById>>, TError = ErrorType<unknown>>(
 userId: string,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAssetById>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserAssetByIdQueryOptions(userId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Authorities: **Any authenticated role**
 */
export const deleteUserAsset = (
    userId: string,
    id: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/${userId}/user-assets/${id}`, method: 'DELETE', signal
    },
      options);
    }



export const getDeleteUserAssetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserAsset>>, TError,{userId: string;id: number}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUserAsset>>, TError,{userId: string;id: number}, TContext> => {

const mutationKey = ['deleteUserAsset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUserAsset>>, {userId: string;id: number}> = (props) => {
          const {userId,id} = props ?? {};

          return  deleteUserAsset(userId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserAssetMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUserAsset>>>

    export type DeleteUserAssetMutationError = ErrorType<unknown>

    export const useDeleteUserAsset = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserAsset>>, TError,{userId: string;id: number}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUserAsset>>,
        TError,
        {userId: string;id: number},
        TContext
      > => {
      return useMutation(getDeleteUserAssetMutationOptions(options), queryClient);
    }
    /**
 * Authorities: **Any authenticated role**
 */
export const downloadUserAsset = (
    userId: string,
    id: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<Blob>(
      {url: `/api/${userId}/user-assets/${id}/download`, method: 'GET', signal
    },
      options);
    }




export const getDownloadUserAssetQueryKey = (userId: string,
    id: number,) => {
    return [
    `/api/${userId}/user-assets/${id}/download`
    ] as const;
    }


export const getDownloadUserAssetQueryOptions = <TData = Awaited<ReturnType<typeof downloadUserAsset>>, TError = ErrorType<unknown>>(userId: string,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadUserAsset>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadUserAssetQueryKey(userId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadUserAsset>>> = ({ signal }) => downloadUserAsset(userId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(userId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadUserAsset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadUserAssetQueryResult = NonNullable<Awaited<ReturnType<typeof downloadUserAsset>>>
export type DownloadUserAssetQueryError = ErrorType<unknown>


export function useDownloadUserAsset<TData = Awaited<ReturnType<typeof downloadUserAsset>>, TError = ErrorType<unknown>>(
 userId: string,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadUserAsset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadUserAsset>>,
          TError,
          Awaited<ReturnType<typeof downloadUserAsset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadUserAsset<TData = Awaited<ReturnType<typeof downloadUserAsset>>, TError = ErrorType<unknown>>(
 userId: string,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadUserAsset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadUserAsset>>,
          TError,
          Awaited<ReturnType<typeof downloadUserAsset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadUserAsset<TData = Awaited<ReturnType<typeof downloadUserAsset>>, TError = ErrorType<unknown>>(
 userId: string,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadUserAsset>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDownloadUserAsset<TData = Awaited<ReturnType<typeof downloadUserAsset>>, TError = ErrorType<unknown>>(
 userId: string,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadUserAsset>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadUserAssetQueryOptions(userId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Authorities: **Any authenticated role**
 */
export const countUserAssets = (
    userId: string,
    params: CountUserAssetsParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<number>(
      {url: `/api/${userId}/user-assets/count`, method: 'GET',
        params, signal
    },
      options);
    }




export const getCountUserAssetsQueryKey = (userId: string,
    params?: CountUserAssetsParams,) => {
    return [
    `/api/${userId}/user-assets/count`, ...(params ? [params] : [])
    ] as const;
    }


export const getCountUserAssetsQueryOptions = <TData = Awaited<ReturnType<typeof countUserAssets>>, TError = ErrorType<unknown>>(userId: string,
    params: CountUserAssetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countUserAssets>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCountUserAssetsQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof countUserAssets>>> = ({ signal }) => countUserAssets(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof countUserAssets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CountUserAssetsQueryResult = NonNullable<Awaited<ReturnType<typeof countUserAssets>>>
export type CountUserAssetsQueryError = ErrorType<unknown>


export function useCountUserAssets<TData = Awaited<ReturnType<typeof countUserAssets>>, TError = ErrorType<unknown>>(
 userId: string,
    params: CountUserAssetsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof countUserAssets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countUserAssets>>,
          TError,
          Awaited<ReturnType<typeof countUserAssets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCountUserAssets<TData = Awaited<ReturnType<typeof countUserAssets>>, TError = ErrorType<unknown>>(
 userId: string,
    params: CountUserAssetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countUserAssets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countUserAssets>>,
          TError,
          Awaited<ReturnType<typeof countUserAssets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCountUserAssets<TData = Awaited<ReturnType<typeof countUserAssets>>, TError = ErrorType<unknown>>(
 userId: string,
    params: CountUserAssetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countUserAssets>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCountUserAssets<TData = Awaited<ReturnType<typeof countUserAssets>>, TError = ErrorType<unknown>>(
 userId: string,
    params: CountUserAssetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countUserAssets>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCountUserAssetsQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






